import { useQuery } from '@tanstack/react-query';
import {
  fetch_commerce_counts,
  fetch_commerce_order_detail,
  fetch_commerce_order_list,
} from './api';
import type { CommerceOrderListFilters } from './types';
import type { SortState } from '@/hooks/use-url-state';

const KEYS = {
  list: (filters: CommerceOrderListFilters, sort?: SortState) =>
    ['admin-commerce-order-list', filters, sort] as const,
  counts: () => ['admin-commerce-order-counts'] as const,
  detail: (id: string) => ['admin-commerce-order-detail', id] as const,
};

export function use_commerce_order_list(filters: CommerceOrderListFilters, sort?: SortState) {
  return useQuery({
    queryKey: KEYS.list(filters, sort),
    queryFn: () => fetch_commerce_order_list(filters, sort),
    placeholderData: (prev) => prev,
  });
}

/** Counts for the tiles, including the shipment-level backlog. */
export function use_commerce_counts() {
  return useQuery({ queryKey: KEYS.counts(), queryFn: fetch_commerce_counts });
}

export function use_commerce_order_detail(id: string | undefined) {
  return useQuery({
    queryKey: id ? KEYS.detail(id) : ['admin-commerce-order-detail', 'noop'],
    queryFn: () => fetch_commerce_order_detail(id as string),
    enabled: typeof id === 'string' && id.length > 0,
  });
}
